import React from 'react'
import PT from 'prop-types'
import c from 'classnames'
import Hammer from 'react-hammerjs'

import './FlipChip.scss'

export default class FlipChip extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = { flipped: false }

    this.toggleFlip = () =>
      this.setState({
        flipped:
          !!this.props.back && !this.props.isLoading && !this.state.flipped,
      })
  }

  render() {
    let { className, mini, front, back, flip } = this.props,
      { flipped } = this.state

    return (
      <div
        className={c('flip-chip', className, `flip-${flip}`, {
          'is-mini': mini,
          'is-flipped': flipped,
        })}
      >
        <Hammer onSwipe={this.toggleFlip} direction="DIRECTION_HORIZONTAL">
          <div className="flipper">
            <div className="flip-chip-front">
              {front({ flipped, flip: this.toggleFlip, side: 'front' })}
            </div>{' '}
            <div className="flip-chip-back">
              {back({ flipped, flip: this.toggleFlip, side: 'back' })}
            </div>
          </div>
        </Hammer>
      </div>
    )
  }
}

FlipChip.propTypes = {
  className: PT.string,
  mini: PT.bool,
  front: PT.func,
  back: PT.func,
}

FlipChip.defaultProps = {
  className: '',
  mini: false,
  flip: 'horizontal',
  front: () => {},
  back: () => {},
}
